import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { initSeon } from "@nxplatform/helpers/vendors/seon";
initSeon();
const PlatformRouter = ({ platformRoutes }) => {
  const router = createBrowserRouter(platformRoutes);
  return /* @__PURE__ */ jsx(RouterProvider, { router });
};
const _PlatformRouter = memo(PlatformRouter);
export {
  _PlatformRouter as PlatformRouter
};
